import { render, staticRenderFns } from "./OrgModal.vue?vue&type=template&id=591c768e&scoped=true"
import script from "./OrgModal.vue?vue&type=script&lang=js"
export * from "./OrgModal.vue?vue&type=script&lang=js"
import style0 from "./OrgModal.vue?vue&type=style&index=0&id=591c768e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591c768e",
  null
  
)

export default component.exports